import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Navbar from "../../components/shared/Navbar/Navbar";
import Footer from "../../components/shared/Footer/Footer";
import AllSectorsHero from "../../components/pages/AllSectors/AllSectorsHero/AllSectorsHero";
import AllSectorsSectors from "../../components/pages/AllSectors/AllSectorsSectors/AllSectorsSectors";
import AllSolutionsRequestNewProject from "../../components/pages/AllSolutions/AllSolutionsRequestNewProject/AllSolutionsRequestNewProject";
import { findPageSection, unwrapSectionData } from "../../utils/aboutStartNewProjectSection";
import { usePageContentAliases, usePublicSectors } from "../../hooks/usePublicQueries";

const SECTORS_PAGE_ALIASES = ["allsectors", "all-sectors", "sectors", "allsector"];

const AllSectors = () => {
  const { i18n } = useTranslation();
  const { data: sectors } = usePublicSectors(i18n.language);
  const { data: pageContent } = usePageContentAliases(SECTORS_PAGE_ALIASES, i18n.language);

  const heroSection = useMemo(
    () =>
      findPageSection(pageContent, "hero") ||
      findPageSection(pageContent, "allsectorshero") ||
      findPageSection(pageContent, "allsectors"),
    [pageContent]
  );

  return (
      <div className="sectors-page">
        <Navbar theme="light" />
        <AllSectorsHero content={unwrapSectionData(heroSection)} />
        <div className="sectors-page-content-guide">
          <div id="sectors-explore">
            <AllSectorsSectors sectors={sectors} />
          </div>
          <AllSolutionsRequestNewProject />
        </div>
        <Footer />
      </div>
  );
};

export default AllSectors;
